const STORAGE_KEY = 'EXTERNAL_ENTITY_ID'

export class Identifier {
  static setEntity(entity) {
    localStorage.setItem(STORAGE_KEY, `${entity}`)
  }

  static entityExists(entity) {
    const identifier = localStorage.getItem(STORAGE_KEY)

    return `${identifier}` === `${entity}`
  }
}
